import { render, staticRenderFns } from "./headView.vue?vue&type=template&id=6a5678d1&scoped=true"
import script from "./headView.vue?vue&type=script&lang=js"
export * from "./headView.vue?vue&type=script&lang=js"
import style0 from "./headView.vue?vue&type=style&index=0&id=6a5678d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5678d1",
  null
  
)

export default component.exports